import BlankEtc from '@components/blank/BlankEtc';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';

function CheckingService() {
    const project = useProject();
    if (project?.status === 'PENDING' || project?.status === 'CLOSED') {
        return (
            <Container>
                <BlankEtc>
                    <Text size='3xl'>서비스 점검중입니다.</Text>
                </BlankEtc>
            </Container>
        );
    }
    return null;
}

const Container = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: white;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export default CheckingService;
